import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ roles }) {
  const { loading, user } = useAuth();

  if (loading) {
    return <div className="p-8 text-sm font-semibold text-slate-600">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/account" replace />;
  }

  if (roles?.length && !roles.includes(user.role)) {
    return <Navigate to="/my-account" replace />;
  }

  return <Outlet />;
}
